import "./styles.scss";
import { memo, useEffect, useMemo, useState } from "react";
// import CircleNumber from "../CircleNumber";
// import CartConfirm from "./components/CartConfirm";
// import ModalConfirm from "../CartTicketLine/components/ModalConfirm";
import { enterContest, getRound } from "../../utils/utils";
// import useDeviceDetect from "../../hook/useDeviceDetect";
import { formatNumber } from "../../services/utility/utils";
// import EntryButton from "./components/EntryButton";
// import TickerLine from "./components/CartConfirm/components/TickerLine";
import { useDispatch, useSelector } from "react-redux";
// import ContestOdd from "./components/ContestOdd";
// import { ReactComponent as UpDownIcon } from "../../assets/images/up-down-icon.svg";
// import { ReactComponent as UpDownIcon2 } from "../../assets/images/up-down-icon_v1.svg";

import { useTheme } from "../../hook/useThemes";
import CardLive from "./components/CardLive";
import CartOpenedNew from "./components/CartOpenedNew";
import useScreen from "../../hook/useScreen";
import { addContestPlayed } from "../../redux/contests/actions";
import { setAuth } from "../../redux/auth/actions";
import CartLiveV1 from "./components/CartLiveV1";
import CountDown from "../CountDown";
import { useSearchParams } from "react-router-dom";

type TypeCardTicket = {
  zIndex?: number;
  contest?: any;
};

const CartTicket = ({ zIndex = 1, contest }: TypeCardTicket) => {
  // const { status } = contest;
  const [searchParams] = useSearchParams();
  const assetType = searchParams.get("assetType") || "USD";

  const status =
    contest?.status?.toLowerCase() === "voided" ? "Live" : contest?.status;

  const { settingCard, lang, operatorId, fixed_odds } = useTheme();
  const { tracker = "vertical" } = settingCard;
  const [selectType, setSelectType] = useState<string>("");

  const [loadingConfirm, setLoadingConfirm] = useState<boolean>(false);
  const [oldOdd, setOldOdd] = useState<number>(0);

  const [isSuccess, setIsSuccess] = useState<boolean>();
  const [isError, setIsError] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string>("");
  const [isBet, setIsBet] = useState<boolean>(false);
  const [isInsufficientFunds, setIsInsufficientFunds] =
    useState<boolean>(false);
  const [isOddChange, setIsOddChange] = useState<boolean>(false);
  const [resultError, setResultError] = useState<boolean>(false);



  // const lockPriceDefault = contest?.closePrice || "Loading";
  // const coinValue = useSelector((state: any) => state?.coinPrices?.BTC || 0);
  const { balance, ...auth } = useSelector((state: any) => state?.auth);
  const valueBet = useSelector((state: any) => state?.coinPrices?.bet || 0);

  const dispatch = useDispatch();
  const heightScreen = useScreen();
  // const isHeightMin = heightScreen <= SCREEN_LIST.screenHeight3;

  const handleConfirm = async (type: string) => {
    const newValue = {
      contestId: contest.id,
      wager: `${valueBet}`,
      ...auth,
      cardType: type === "above" ? "moon" : "rekt",
      assetType: assetType,
      moonOdds: contest.whitelabelMoonOdds || 0,
      rektOdds: contest.whitelabelRektOdds || 0,
    };
    const currentOdd =
      type === "below"
        ? contest?.whitelabelRektOdds || 0
        : contest?.whitelabelMoonOdds || 0;

    setOldOdd(currentOdd);

    const whitelabelRektOdds = contest?.whitelabelRektOdds;
    const whitelabelMoonOdds = contest?.whitelabelMoonOdds;

    await enterContest(newValue)
      .then((data) => {
        setIsSuccess(true);
        setLoadingConfirm(false);
        dispatch(
          addContestPlayed({
            id: contest.id,
            wager: data?.contestEntry?.wager || valueBet,
            time: contest.duration,
            position: type === "above" ? "moon" : "rekt",
            whitelabelRektOdds,
            whitelabelMoonOdds,
          })
        );
        const newBalance = balance - valueBet;
        dispatch(setAuth({ ...auth, balance: newBalance }));
      })
      .catch((e) => {
        if (typeof e?.detail === "string") {
          setMsgError(e?.detail);
        }
        setLoadingConfirm(false);
        setIsError(true);
      });
  };

  const handleClickTicket = (value: any) => {
    if (valueBet > balance) {
      setIsInsufficientFunds(true);
      return;
    }
    if (loadingConfirm || !valueBet) return;
    setLoadingConfirm(true);
    setSelectType(value);
    handleConfirm(value);
    setIsBet(true);
  };

  const isNextRound =
    status !== "Live" &&
    new Date(contest?.contestLiveTime).getTime() - new Date().getTime() < 60000;

  const hasEntry = !!contest?.position;

  // Calculate statuses of the card
  const classes = [`${status}`.toLowerCase(), `z-index-${zIndex}`];

  if (hasEntry) {
    classes.push(contest?.position === "moon" ? "above" : "below");
  }

  if (!isNextRound && status !== "Live") {
    classes.push("later-round");
  }

  useEffect(() => {
    if (status === "Live") {
      setIsSuccess(false);
      setSelectType("");
      setOldOdd(0);
      setIsError(false);
    }
    if (status !== "Live" && hasEntry) {
      setIsSuccess(true);
    }
  }, [status, hasEntry]);

  useEffect(() => {
    if (hasEntry && !oldOdd) {
      const type = contest?.position === "moon" ? "above" : "below";
      const currentOdd =
        type === "below"
          ? contest?.whitelabelRektOdds || 0
          : contest?.whitelabelMoonOdds || 0;
      setOldOdd(currentOdd);
    }
  }, [contest, hasEntry, oldOdd]);

  const type = selectType
    ? selectType
    : contest?.position === "moon"
    ? "above"
    : contest?.position === "rekt"
    ? "below"
    : "";

  useMemo(() => {
    if (resultError) {
      return;
    }
    if (!isError) {
      setIsOddChange(false);
      return;
    }
    const currentOdd =
      selectType === "below"
        ? contest?.whitelabelRektOdds || 0
        : contest?.whitelabelMoonOdds || 0;
    if (currentOdd !== oldOdd && oldOdd !== 0 && !!oldOdd) {
      setIsOddChange(true);
      setResultError(true)
      return;
    }
    setResultError(true)
    setIsOddChange(false);
    return;
  }, [
    isError,
    oldOdd,
    contest?.whitelabelRektOdds,
    contest?.whitelabelMoonOdds,
    selectType,
    resultError
  ]);

  return (
    <div className={tracker === "vertical" && `wrapper-card-${status}`}>
      <div
        className={`wrapper-card ${classes.join(" ")} 
          ${
            !fixed_odds &&
            status !== "Live" &&
            !isNextRound &&
            "opened-secondary"
          }

          ${
            fixed_odds &&
            status !== "Live" &&
            !contest?.whitelabelRektOdds &&
            !contest?.whitelabelMoonOdds &&
            "opened-secondary"
          }
        `}
        style={{
          borderRadius: settingCard.borderRadius || "0px",
        }}
      >
        {(tracker === "horizontal" || status === "Opened") && (
          <>
            <div
              className={`card-title ${operatorId === 1 && "card-title-min"}`}
            >
              <div className="round">
                {lang?.round || "Round"} #{getRound(contest?.contestLiveTime)}
              </div>
              <div className="name">
                {status === "Live" && (
                  <span className="title-live">
                    {operatorId === 1 && (
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 6L4.5 8.59808L4.5 3.40192L9 6Z"
                          fill="white"
                        />
                        <circle cx="6" cy="6" r="5.5" stroke="#00FF00" />
                      </svg>
                    )}
                    {lang?.live || "LIVE"}
                  </span>
                )}
                {isNextRound &&
                  !fixed_odds &&
                  (lang?.next_round || "Next Round")}
                {fixed_odds && (
                  <CountDown
                    expiryTime={contest?.contestLiveTime}
                    prefix={lang?.starts_in}
                  />
                )}
              </div>

              <div className="amount">
                {!!contest?.prizePool &&
                  !fixed_odds &&
                  !!contest?.whitelabelMoonOdds &&
                  !!contest?.whitelabelRektOdds && (
                    <>${formatNumber(contest?.prizePool, 2)}</>
                  )}
              </div>
            </div>
          </>
        )}

        {/* Live contest */}
        {status === "Live" && tracker === "horizontal" && (
          <CardLive contest={contest} type={type} />
        )}
        {status === "Live" && tracker === "vertical" && (
          <CartLiveV1 contest={contest} />
        )}

        {/* Openned contest */}

        {status === "Opened" && (
          <CartOpenedNew
            contest={contest}
            heightScreen={heightScreen}
            isNextRound={isNextRound}
            handleClickTicket={handleClickTicket}
            hasEntry={hasEntry}
            type={type}
            loadingConfirm={loadingConfirm}
            isSuccess={isSuccess}
            wager={contest?.wager || valueBet}
            isError={isError}
            // time={time}
            operatorId={operatorId}
            lang={lang}
            isBet={isBet}
            fixedOdds={fixed_odds}
            isOddChange={isOddChange}
            onConfirm={() => {
              setLoadingConfirm(true);
              handleConfirm(selectType);
              setIsOddChange(false);
              setResultError(false);
              setIsError(false);
            }}
            onCancel={() => {
              setSelectType("");
              setLoadingConfirm(false);
              setIsSuccess(false);
              setIsOddChange(false);
              setIsError(false);
              setResultError(false);
            }}
            oldOdd={oldOdd}
            isInsufficientFunds={isInsufficientFunds}
            onCloseInsufficientFunds={() => setIsInsufficientFunds(false)}
            msgError={msgError}
            zIndex={zIndex}
            onCloseErrorBet={() => {
              setSelectType("");
              setLoadingConfirm(false);
              setIsSuccess(false);
              setIsOddChange(false);
              setIsError(false);
              setResultError(false);
            }}
          />
        )}
      </div>
      {tracker === "vertical" && <article className="faux"></article>}
    </div>
  );
};

export default memo(CartTicket);
